var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panels",
    {
      staticClass: "mt-1 animate__animated animate__fadeIn",
      attrs: { accordian: "", flat: "" },
      model: {
        value: _vm.panel,
        callback: function ($$v) {
          _vm.panel = $$v
        },
        expression: "panel",
      },
    },
    [
      _vm._l(_vm.lessons, function (item, index) {
        return _c(
          "v-expansion-panel",
          {
            key: item.id + item.student.id,
            class: ["mb-2 mt-0 px-1", `panel-${index}`],
          },
          [
            _c(
              "v-expansion-panel-header",
              {
                class: [
                  "soli-round schedule-list-items elevation-4 mb-1",
                  item.attendance.status == "Early-cancel"
                    ? "click-events"
                    : null,
                ],
                attrs: { focusable: "", "expand-icon": "keyboard_arrow_down" },
                on: {
                  click: function ($event) {
                    ;[(_vm.selectedLesson = item), _vm.$log(item.id)]
                  },
                },
              },
              [
                _c(
                  "v-row",
                  {
                    class: [
                      "align-center",
                      item.cancelled ? "grey-text" : "soli-grey",
                    ],
                  },
                  [
                    _c("div", {
                      staticClass: "date-indicator",
                      class: [
                        "mr-5",
                        item.cancelled
                          ? "soli-attendance-grey shadow-l"
                          : item.attendance.status == "Attended"
                          ? "soli-status-green"
                          : "soli-blue",
                      ],
                    }),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "col-auto align-self-center text-align-center",
                      },
                      [
                        _c("div", { staticClass: "caption" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.globalMomentMonth(item.starts_at)) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.globalMomentDay(item.starts_at)) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c("v-list", { staticClass: "mx-2" }, [
                          _c("div", { staticClass: "caption" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(`${_vm.globalMomentDateAtTime(
                                  item.starts_at
                                )} · ${item.duration} min
                                                `) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          !item.group_event
                            ? _c(
                                "div",
                                {
                                  class: _vm.$vuetify.breakpoint.xsOnly
                                    ? "body-2"
                                    : "body-1",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        item.type == "Weekly Lesson"
                                          ? `${
                                              _vm.hasFamily
                                                ? `${item.student.first_name}'s `
                                                : ""
                                            }${item.instrument.name} Lesson`
                                          : `${
                                              _vm.hasFamily
                                                ? `${item.student.first_name}'s `
                                                : ""
                                            }${item.instrument.name} ${
                                              item.type
                                            }`
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  class: _vm.$vuetify.breakpoint.xsOnly
                                    ? "body-2"
                                    : "body-1",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        `${item.student.first_name}'s ${item.group_event.title}`
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "caption" }, [
                            _vm._v(
                              "\n                            with\n                            " +
                                _vm._s(item.teacher.first_name) +
                                "\n                            ·\n                            " +
                                _vm._s(
                                  item.online ? "Online" : item.location.name
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-expansion-panel-content",
              [
                item.attendance.status ||
                _vm.getStatusWarning ||
                item.attendance.purchase_option?.ends_at
                  ? _c(
                      "v-list",
                      { staticClass: "pt-5" },
                      [
                        item.attendance.purchase_option?.ends_at
                          ? _c(
                              "v-list-item",
                              { staticClass: "align-start pb-3" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-3",
                                    attrs: { color: "error" },
                                  },
                                  [_vm._v("block")]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "font-bold" }, [
                                    _vm._v("Membership ends on:"),
                                  ]),
                                  _c("br"),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.globalMomentDate(
                                          item.attendance.purchase_option
                                            .ends_at
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.attendance.status || _vm.getStatusWarning
                          ? _c(
                              "v-list-item",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-3",
                                    attrs: {
                                      color: _vm.getStatusWarning
                                        ? "soli-status-red"
                                        : "soli-status-green",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getStatusWarning
                                          ? "error"
                                          : "check_circle"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.getStatusWarning ??
                                          item.attendance.status
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.attendance.lesson_note
                          ? _c(
                              "v-list-item",
                              { staticClass: "align-start pb-3" },
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "soli-blue-text mr-3" },
                                  [_vm._v("notes")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "font-bold" }, [
                                      _vm._v("What we worked on in class:"),
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("TipTapReader", {
                                      attrs: {
                                        value: item.attendance.lesson_note,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.attendance.practice_note
                          ? _c(
                              "v-list-item",
                              { staticClass: "align-start pb-3" },
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "soli-blue-text mr-3" },
                                  [_vm._v("task_alt")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "font-bold" }, [
                                      _vm._v("What you should practice:"),
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("TipTapReader", {
                                      attrs: {
                                        value: item.attendance.practice_note,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canChange(item) ||
                !_vm.pastLesson(item) ||
                _vm.inProgress(item)
                  ? _c(
                      "v-row",
                      { staticClass: "justify-around align-center my-5" },
                      [
                        !_vm.pastLesson(item, true)
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "soli-red-text",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  disabled: item.cancelled ? true : false,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelBtn(item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("cancel")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "mt-1 panel-text" },
                                  [_vm._v("Cancel")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canChange(item) ||
                        !_vm.pastLesson(item) ||
                        _vm.inProgress(item)
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "m-orange-text",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  disabled: !_vm.canChange(item),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.rescheduleBtn(item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("change_circle")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "mt-1 panel-text" },
                                  [_vm._v("Reschedule")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "Assessment" &&
                        !item.attendance?.purchase_option?.paid
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "soli-green-text",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  href: _vm.route("prepay"),
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("attach_money")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "mt-1 panel-text" },
                                  [_vm._v("Pay Now")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.pastLesson(item) || _vm.inProgress(item)
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "soli-blue-text",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  disabled:
                                    item.cancelled ||
                                    !!item.group_event ||
                                    (item.online &&
                                      /*!!item.availability?.online_only*/ !!item
                                        .room.user_id) ||
                                    (item.online && !_vm.canChange(item)),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("move", item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", [
                                  _vm._v(
                                    _vm._s(
                                      item.online ? "storefront" : "videocam"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                !item.online
                                  ? _c(
                                      "small",
                                      { staticClass: "mt-1 panel-text" },
                                      [_vm._v("Move Online")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.online
                                  ? _c(
                                      "small",
                                      { staticClass: "mt-1 panel-text" },
                                      [
                                        _vm._v("Move "),
                                        _c("br"),
                                        _vm._v(
                                          "\n                        In-person"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.online &&
                        item.teacher.zoom_url &&
                        _vm.showNow(item)
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "soli-blue-text",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  href: item.teacher.zoom_url,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("logout")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text flex",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("Join Zoom")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        false /*item.attendance.lesson_note*/
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "soli-blue-text",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("notes", item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("notes")]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass: "mt-1 panel-text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [_vm._v("View Notes")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.lessons.length > 10 && !_vm.loadMore
        ? _c(
            "v-btn",
            {
              staticClass: "soli-round",
              attrs: { text: "", color: "primary", loading: _vm.$root.loading },
            },
            [
              _c(
                "Link",
                {
                  attrs: {
                    preserveState: true,
                    preserveScroll: true,
                    data: { loadMore: 1 },
                    only: [_vm.isPast ? "pastLessons" : "lessons", "loadMore"],
                  },
                },
                [_vm._v("Load More")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }